import { connect } from 'react-redux';
import ContactsAccoladesSection from "../../../components/admin/riaContacts/acordionSections/ContactsAccoladesSection";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const ContactsAccoladesSectionContainer = connect(mapStateToProps, {})(ContactsAccoladesSection)

export default ContactsAccoladesSectionContainer;